'use client'

import useProgressRouter from '@hooks/useProgressRouter'
import getAgentRoute from '@plugin/searchRoute/modules/agent'
import { agentList } from '@router'
import { agentSearchType } from '@routerConfig'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { useCallback, useMemo } from 'react'

export default function FreeAppraisalButton({
  data,
  className = 'button-primary-out'
}) {

  const agentListRoute = useMemo(() => {
    const agentRoute = getAgentRoute()
    agentRoute.setSuburbs({ label: data.suburb, id: data.suburbId, level: 'suburb' })
    return agentList(agentSearchType.residential, agentRoute.toSlug())
  }, [data])

  const { pushRouter } = useProgressRouter()
  const gotoPromotedAgent = useCallback(() => {
    const el = document.getElementById('promoted-agent')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    } else {
      pushRouter(agentListRoute)
    }
  }, [pushRouter, agentListRoute])

  return (
    data.hasPromoteAgents
      ? <button className={className} onClick={gotoPromotedAgent}>Get a free appraisal</button>
      : <DisablePrefetchLink href={agentListRoute} target='_blank' className={className}>Get a free appraisal</DisablePrefetchLink>
  )
}